import React from 'react';
import Plans from './Plans';
import { KINGMAN_INTERNET } from '../data/localSeoContent';

const InternetKingman: React.FC = () => (
  <Plans
    city="Kingman"
    heroTitle="Internet in Kingman, Arizona"
    heroSubtitle="Local wireless internet with WAVE Fiber Speeds for Kingman homes and businesses — reliable service with free installation on featured plans. Check your address to see which coverage and speeds are available where you live."
    localSeo={KINGMAN_INTERNET}
  />
);

export default InternetKingman;
